import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'
import { customerCodeAdd, customerCodeEdit } from '@/api/overseasSales/customerCenter'
import type { FormInstance } from 'ant-design-vue'
import { CustomerCode } from '@/typings/api/customerCenter'
import { message } from '@dc-platform/dc-components'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerCode>({})
const emit = __emit
const toggle = (row?: CustomerCode) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId } = editForm.value
    const p = {
      arkCode,
      cosId
    }
    try {
      if (editForm.value.id) {
        await customerCodeEdit({ ...p, id: editForm.value.id })
      } else {
        await customerCodeAdd(p)
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "arkCode",
                label: "客户名称/代码:",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.value.arkCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.arkCode) = $event)),
                    valueModifiers: { trim: true },
                    placeholder: "请选择"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "arkCode",
                label: "成交额(万/RMB):",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.value.arkCode,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.arkCode) = $event)),
                    valueModifiers: { trim: true },
                    placeholder: "请选择"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})